module.exports = __webpack_public_path__ + "img/Presentations.d4204055.jpg";